<template>
  <div>
    <flat-pickr
      :value="value"
      :config="mergedConfig"
      :placeholder="placeholder"
      @input="emit"
    />
  </div>
</template>

<script type="text/babel">
import flatPickr from 'vue-flatpickr-component'

export default {
  name: 'BaseDatePicker',
  components: {
    flatPickr,
  },
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    config: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    mergedConfig() {
      return Object.assign({
        // Use the non-native picker on mobile
        disableMobile: true,
        enableTime: true,
        // This is how we receive/send dates from/to backend
        dateFormat: this.$date.isoFormat(),
        // This is how we display them in the altInput
        altFormat: this.$date.flatPickerDateTimeFormat(),
        // This is the input that users see and make modifications to
        altInput: true,
        allowInput: true,
      }, this.config)
    },
  },
  methods: {
    emit(dateValue) {
      this.$emit('input', dateValue)
    },
  },
}
</script>

<style>
.flatpickr-disabled {
  color: rgba(57, 57, 57, .3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
</style>
